<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--250" no-body type="secondary">
          <div class="px-4">

              <div class="row justify-content-center">
                <div class="col-sm-12 col-md-8 col-lg-6" ref="relationsholder">
                  <br />

                  Pelaajia:
                      <base-input
                        alternative
                        v-model="numberOfPlayers"
                      />

                  Nimen vähimmäispituus:
                      <base-input
                        alternative
                        v-model="minNameLength"
                      />

                  Nimen enimmäispituus:
                      <base-input
                        alternative
                        v-model="maxNameLength"
                      />

                      <base-button
                        type="primary"
                        v-on:click="onSubmit()"
                      >PÄIVITÄ</base-button>


                  <div v-if="showRelations">
                    <RelationsECharts
                      :key="relationsComponentKey"
                      :initialCanvasWidth="500"
                      :selectedCaseNumber="1"
                    />
                  </div>
                </div>
              </div>
            </div>
          <br />
        </card>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import RelationsECharts from "@/components/RelationsECharts.vue";

export default {
  components: {
    RelationsECharts,
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=5, user-scalable=1' },
    ]
  },  
  data: function() {
    return {
      numberOfPlayers: 5,
      minNameLength: 5,
      maxNameLength: 15,
      showRelations: false,
      relationsComponentKey: 1
    };
  },
  methods: {
    onSubmit() {
      let i = 0;
      const players = []
      const nominations = []
      for (i = 0; i < this.numberOfPlayers; i++) {       
        const player = {}
        player.id = i;
        player.nick_name = this.generateName();
        players.push(player)

        const nomination = {}
        nomination.id = i;        
        nomination.player = i;
        nomination.nominee = Math.floor(Math.random() * this.numberOfPlayers)
        nomination.case_number = 1;
        nominations.push(nomination)
      }
/*      console.log("Data:")
      console.log(JSON.stringify(players))
      console.log(JSON.stringify(nominations))
*/
      this.$store.commit({
        type: "setAllPlayers",
        players: players
      });

      this.$store.commit({
        type: "setNominations",
        nominations: nominations
      });

      this.relationsComponentKey++;
      this.showRelations = true;
    },
    generateName() {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;

      const length = Math.floor(Math.random() * (this.maxNameLength - this.minNameLength + 1)) + this.minNameLength;

      for (let i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;      
    },
    forceRerender() {
      this.componentKey += 1;
    },
  }
};
</script>
